var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuGeneralOutdoorT = function SvgDAhuGeneralOutdoorT(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 139,
    cy: 294,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,284c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S133.5,284,139,284 M139,283c-6.1,0-11,4.9-11,11s4.9,11,11,11 s11-4.9,11-11S145.1,283,139,283L139,283z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.4,291.5h-1.8v4.9h-1v-4.9h-1.8v-0.8h4.5V291.5z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 305,
    width: 2,
    height: 22
  })))));
};
export default SvgDAhuGeneralOutdoorT;